import { render, staticRenderFns } from "./u-row-notice.vue?vue&type=template&id=4661e472&scoped=true&"
import script from "./u-row-notice.vue?vue&type=script&lang=js&"
export * from "./u-row-notice.vue?vue&type=script&lang=js&"
import style0 from "./u-row-notice.vue?vue&type=style&index=0&id=4661e472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661e472",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-row-notice/u-row-notice.vue"
export default component.exports